(function () {
  'use strict';

  var TRANSITION_MS = 320;

  function initStickyAtc(section) {
    if (!section || !section.matches || !section.matches('section[data-section-type="product"]')) {
      return;
    }

    var root = section.querySelector('[data-sticky-atc-root]');
    if (!root) return;

    if (section._stickyAtcCleanup) {
      section._stickyAtcCleanup();
      section._stickyAtcCleanup = null;
    }

    var panel = root.querySelector('.sticky-atc-bar__panel');
    var priceTarget = root.querySelector('[data-sticky-atc-price]');
    var promoTarget = root.querySelector('[data-sticky-atc-promo]');
    var addBtn = root.querySelector('[data-sticky-atc-add]');
    var mainAdd = section.querySelector('.product-form__add-button');
    var mainPriceList = section.querySelector('.product-form__info-list .price-list');
    var mainQtyInput = section.querySelector('.quantity-selector--product .quantity-selector__value');
    var mainQtyDec = section.querySelector('.quantity-selector--product [data-action="decrease-picker-quantity"]');
    var mainQtyInc = section.querySelector('.quantity-selector--product [data-action="increase-picker-quantity"]');
    var showQty = root.getAttribute('data-show-quantity') === 'true';
    var qtyValueEl = root.querySelector('[data-sticky-atc-qty-value]');
    var qtyDec = root.querySelector('[data-sticky-atc-qty-dec]');
    var qtyInc = root.querySelector('[data-sticky-atc-qty-inc]');
    var stickyVariantSelect = root.querySelector('[data-sticky-atc-variant-select]');

    var visible = false;
    var io = null;
    var onQtyInput = null;
    var onVariant = null;
    var onResize = null;
    var transitionEndHandler = null;
    var onStickyVariantChange = null;

    function getProductJson(sectionEl) {
      var el = sectionEl.querySelector('script[data-product-json]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    function setMainOptionValueAndNotify(sectionEl, position, value) {
      var nodes = sectionEl.querySelectorAll(
        '.product-form__single-selector[data-option-position="' + position + '"]'
      );
      var i;
      for (i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.tagName === 'SELECT') {
          if (el.value !== value) {
            el.value = value;
          }
          el.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
      for (i = 0; i < nodes.length; i++) {
        var r = nodes[i];
        if (r.tagName === 'INPUT' && r.type === 'radio' && r.classList.contains('product-form__single-selector')) {
          if (r.value === value) {
            if (!r.checked) {
              r.checked = true;
            }
            r.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
      }
    }

    function applyVariantIdToMain(sectionEl, variantId) {
      var data = getProductJson(sectionEl);
      if (!data || !data.product || !data.product.variants) return;
      var variant = null;
      for (var v = 0; v < data.product.variants.length; v++) {
        if (String(data.product.variants[v].id) === String(variantId)) {
          variant = data.product.variants[v];
          break;
        }
      }
      if (!variant) return;
      var opts = data.product.options;
      var optCount = Array.isArray(opts) ? opts.length : 0;
      for (var pos = 1; pos <= optCount; pos++) {
        var key = 'option' + pos;
        var val = variant[key];
        if (val === undefined || val === null) continue;
        setMainOptionValueAndNotify(sectionEl, pos, String(val));
      }
    }

    function getSelectedVariantIdFromDom(sectionEl) {
      var pid = root.getAttribute('data-product-id');
      if (pid) {
        var master = sectionEl.querySelector('#product-select-' + pid);
        if (master && master.value) return master.value;
      }
      var hid = sectionEl.querySelector('form.product-form input[name="id"]');
      if (hid && hid.value) return hid.value;
      return null;
    }

    function syncStickyVariantSelect() {
      if (!stickyVariantSelect) return;
      var id = getSelectedVariantIdFromDom(section);
      if (!id) return;
      var found = null;
      var o;
      for (o = 0; o < stickyVariantSelect.options.length; o++) {
        if (String(stickyVariantSelect.options[o].value) === String(id)) {
          found = stickyVariantSelect.options[o];
          break;
        }
      }
      if (!found || found.disabled) return;
      if (String(stickyVariantSelect.value) !== String(id)) {
        stickyVariantSelect.value = id;
      }
    }

    function copyPrice() {
      if (!mainPriceList || !priceTarget) return;
      priceTarget.innerHTML = mainPriceList.innerHTML;
    }

    function syncPromo() {
      if (!promoTarget) return;
      var source = section.querySelector('.product-meta__label-list');
      if (!source || source.innerHTML.trim() === '') {
        promoTarget.innerHTML = '';
        promoTarget.hidden = true;
        return;
      }
      promoTarget.innerHTML = source.innerHTML;
      promoTarget.hidden = false;
    }

    function syncQtyDisplay() {
      if (!showQty || !qtyValueEl || !mainQtyInput) return;
      qtyValueEl.textContent = mainQtyInput.value || '1';
    }

    function syncAddButton() {
      if (!addBtn || !mainAdd) return;
      addBtn.innerHTML = mainAdd.innerHTML;
      if (mainAdd.disabled || mainAdd.getAttribute('data-action') !== 'add-to-cart') {
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.setAttribute('aria-disabled', 'true');
      } else {
        addBtn.removeAttribute('disabled');
        addBtn.removeAttribute('aria-disabled');
      }
    }

    function applyScrollPadding() {
      if (!panel) return;
      if (visible) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', panel.offsetHeight + 'px');
      } else {
        document.documentElement.style.removeProperty('--sticky-atc-bar-height');
      }
    }

    function applyVisibility(show) {
      if (show === visible) return;
      visible = show;
      root.classList.toggle('sticky-atc-bar--visible', show);
      root.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.documentElement.classList.toggle('sticky-atc-bar-active', show);

      if (transitionEndHandler && panel) {
        panel.removeEventListener('transitionend', transitionEndHandler);
        transitionEndHandler = null;
      }

      if (show) {
        window.requestAnimationFrame(function () {
          applyScrollPadding();
        });
      } else {
        transitionEndHandler = function (e) {
          if (e.propertyName !== 'transform' && e.propertyName !== 'opacity') return;
          panel.removeEventListener('transitionend', transitionEndHandler);
          transitionEndHandler = null;
          applyScrollPadding();
        };
        if (panel) {
          panel.addEventListener('transitionend', transitionEndHandler);
        }
        window.setTimeout(function () {
          if (transitionEndHandler) {
            panel.removeEventListener('transitionend', transitionEndHandler);
            transitionEndHandler = null;
            applyScrollPadding();
          }
        }, TRANSITION_MS + 50);
      }
    }

    function onIntersect(entries) {
      var entry = entries[0];
      if (!entry || !mainAdd) return;
      var mainVisible = entry.isIntersecting;
      applyVisibility(!mainVisible);
    }

    copyPrice();
    syncPromo();
    syncQtyDisplay();
    syncAddButton();
    syncStickyVariantSelect();

    if (mainAdd && window.IntersectionObserver) {
      io = new IntersectionObserver(onIntersect, {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px 0px 0px'
      });
      io.observe(mainAdd);
    }

    onVariant = function () {
      window.requestAnimationFrame(function () {
        copyPrice();
        syncPromo();
        syncAddButton();
        syncQtyDisplay();
        syncStickyVariantSelect();
        applyScrollPadding();
      });
    };
    section.addEventListener('variant:changed', onVariant);

    if (stickyVariantSelect) {
      onStickyVariantChange = function () {
        applyVariantIdToMain(section, stickyVariantSelect.value);
      };
      stickyVariantSelect.addEventListener('change', onStickyVariantChange);
    }

    if (showQty && mainQtyInput) {
      onQtyInput = function () {
        syncQtyDisplay();
      };
      mainQtyInput.addEventListener('input', onQtyInput);
      mainQtyInput.addEventListener('change', onQtyInput);
    }

    if (addBtn && mainAdd) {
      addBtn.addEventListener('click', function () {
        if (mainAdd.disabled) return;
        mainAdd.click();
      });
    }

    if (showQty && qtyDec && mainQtyDec) {
      qtyDec.addEventListener('click', function () {
        mainQtyDec.click();
        window.requestAnimationFrame(syncQtyDisplay);
      });
    }
    if (showQty && qtyInc && mainQtyInc) {
      qtyInc.addEventListener('click', function () {
        mainQtyInc.click();
        window.requestAnimationFrame(syncQtyDisplay);
      });
    }

    onResize = function () {
      if (visible) applyScrollPadding();
    };
    window.addEventListener('resize', onResize);

    section._stickyAtcCleanup = function () {
      if (io) {
        io.disconnect();
        io = null;
      }
      section.removeEventListener('variant:changed', onVariant);
      if (stickyVariantSelect && onStickyVariantChange) {
        stickyVariantSelect.removeEventListener('change', onStickyVariantChange);
      }
      if (mainQtyInput && onQtyInput) {
        mainQtyInput.removeEventListener('input', onQtyInput);
        mainQtyInput.removeEventListener('change', onQtyInput);
      }
      window.removeEventListener('resize', onResize);
      if (panel && transitionEndHandler) {
        panel.removeEventListener('transitionend', transitionEndHandler);
      }
      visible = false;
      root.classList.remove('sticky-atc-bar--visible');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('sticky-atc-bar-active');
      document.documentElement.style.removeProperty('--sticky-atc-bar-height');
    };
  }

  function boot() {
    var barRoot = document.querySelector('[data-sticky-atc-root]');
    if (!barRoot) return;
    var section = barRoot.closest('section[data-section-type="product"]');
    if (!section) return;
    initStickyAtc(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    var innerSection = target.querySelector('section[data-section-type="product"]');
    if (innerSection) {
      initStickyAtc(innerSection);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    var innerSection = target.querySelector('section[data-section-type="product"]');
    if (innerSection && innerSection._stickyAtcCleanup) {
      innerSection._stickyAtcCleanup();
      innerSection._stickyAtcCleanup = null;
    }
  });
})();
